import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Form, Button } from 'react-bootstrap';

const propTypes = {
    show: PropTypes.bool,
    title: PropTypes.string.isRequired,
    messageText: PropTypes.string,
    promptText: PropTypes.string.isRequired,
    placeholderText: PropTypes.string,
    confirmButtonText: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    requireText: PropTypes.bool,
};

const defaultProps = {
    confirmButtonText: 'Confirm',
    show: false,
    requireText: false,
};

class GenericTextInputModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            text: '',
        };

        this.onTextChange = this.onTextChange.bind(this);
        this.submitHandler = this.submitHandler.bind(this);
    }

    onTextChange(e) {
        this.setState({ text: e.target.value });
    }

    submitHandler(e) {
        if (this.props.requireText && !this.state.text) return;
        this.props.onConfirm(this.state.text);
    }

    render() {
        return (
            <Modal
                show={this.props.show}
                enforceFocus={false}
                backdrop={false}
                animation={false}
                keyboard
                onHide={this.onClose}
            >
                <Modal.Header closeButton onHide={this.props.onClose}>
                    <Modal.Title>{this.props.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="message">{this.props.messageText}</div>
                    <Form>
                        <Form.Group>
                            <Form.Label>{this.props.promptText}</Form.Label>
                            <Form.Control
                                aria-label={this.props.promptText}
                                value={this.state.text}
                                placeholder={this.props.placeholderText}
                                onChange={this.onTextChange}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        onClick={this.submitHandler}
                        disabled={this.props.requireText && !this.state.text}
                    >
                        {this.props.confirmButtonText}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

GenericTextInputModal.propTypes = propTypes;
GenericTextInputModal.defaultProps = defaultProps;

export default GenericTextInputModal;